import { IsString, MaxLength } from 'class-validator';

export class PricelistSearchDTO {

    @IsString()
    @MaxLength(50)
    name: string;

}
